import request from './request';

const Api = {
  signIn: ({ email, password, rememberMe = '1', loginWithEmail = '1' }) =>
    request(`/user/login?key_access=${app.key_access}`, 'post', {
      email,
      password,
      rememberMe,
      loginWithEmail,
    }),
  signUp: (userData) =>
    request(`/user/reg?key_access=${app.key_access}`, 'post', userData),
  sendEmail: ({ email }) => request('/user/send-email', 'post', { email }),
  changePassword: ({ password, newPassword, newPasswordConfirm }) =>
    request('/user/change-password', 'post', {
      password,
      newPassword,
      newPasswordConfirm,
    }),
  resetPassword: ({ key, password, passwordConfirm }) =>
    request('/user/reset-password', 'post', {
      key,
      password,
      passwordConfirm,
    }),
  logout: () => request('/user/logout', 'post'),
  profile: () => request('/user/profile'),
  balance: () => request('/user/balance'),
  affiliateStats: () => request('/user/ref'),
  openOrder: (sum, autoCloseAt) =>
    request('/crash/open-order', 'post', { summ: sum, price: autoCloseAt }),
  stopOrder: () => request('/crash/stop-order', 'get'),
  orders: () => request('/crash/orders'),
  currentOrder: () => request('/crash/current-order'),
  crashHistory: () => request('/crash/crash-history'),
  ordersHistory: (hash = null) =>
    request('/crash/orders-history', 'post', { hash }),
  withdraw: ({ sum, service, password, cart }) =>
    request('/billing/withdraw', 'post', {
      sum,
      service,
      password,
      cart,
    }),
  withdrawCrypto: ({ password, address, value, selectedCoin }) =>
    request('/billing/withdraw-crypto', 'post', {
      password,
      address,
      value,
      selectedCoin,
    }),
  deposit: ({ amount, description = '' }) =>
    request('/billing/deposit', 'post', { amount, description }),
  exchange: ({ amount, currencyFrom, currencyTo }) =>
    request('/billing/exchange', 'post', { amount, currencyFrom, currencyTo }),
  withdrawHistory: () => request('/billing/withdraw-history'),
  withdrawCancel: (id) => request('/billing/withdraw-cancel', 'post', { id }),
  depositHistory: () => request('/billing/deposit-history'),
  withdrawHistoryCrypto: () => request('/billing/withdraw-crypto-history'),
  depositHistoryCrypto: () => request('/billing/deposit-crypto-history'),
  promocode: (code) => request('/billing/promocode', 'post', { code }),
  coins: () => request('/billing/coins'),
  wallets: () => request('/user/wallets'),
  createWallet: (coinId) => request('/user/create-wallet', 'post', { coinId }),
};

window.API = Api;
window.request = request;

export default Api;



// WEBPACK FOOTER //
// ./app/api/index.js